import { render, staticRenderFns } from "./HistoryListV2.vue?vue&type=template&id=580450f6&"
import script from "./HistoryListV2.vue?vue&type=script&lang=js&"
export * from "./HistoryListV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports